export default __webpack_public_path__ + "static/media/Spinner-1s-200px.f2f5da08.svg";